import { apiRequest } from "./functionsClient";

/** POST /account/member-summaries/sync — rebuilds leagueMemberSummaries for the current user. */
export function syncCurrentUserMemberSummaries(): Promise<void> {
  return apiRequest("/account/member-summaries/sync", { method: "POST", body: {} });
}

/** DELETE /account — cascades auth user, profile, summaries, storage. */
export function deleteAccount(): Promise<void> {
  return apiRequest("/account", { method: "DELETE" });
}

/** POST /account/memberships/leave */
export function leaveMembership(membershipID: string): Promise<void> {
  return apiRequest("/account/memberships/leave", { method: "POST", body: { membershipID } });
}
